export enum UnitOfMeasurement {
  Sheet = 'Sheet',
  Bag = 'Bag',
  Block = 'Block',
  Bottle = 'Bottle',
  Each = 'Each',
  Gram = 'Gram',
  UsGallon = 'US gallon',
  Kilogram = 'Kilogram',
  KilogramHour = 'Kilogramhour',
  Litre = 'Litre',
  UsPound = 'US pound',
  OngoingMeter = 'Ongoing meter',
  Metre = 'Metre',
  SquareMetre = 'Square metre',
  CubicMetre = 'Cubic metre',
  Millilitre = 'Millilitre',
  Pallet = 'Pallet',
  Roll = 'Roll',
  Sack = 'Sack',
  Set = 'Set',
  Items = 'Items',
  Board = 'Board',
  Thousands = 'Thousands',
  Tonnes = 'Tonnes',
  Other = 'Other'
}

export enum MeasurementType {
  Auto = 'Auto',
  Manual = 'Manual'
}

export enum Status {
  Created = 'Created',
  Edited = 'Edited',
  Deleted = 'Deleted',
  // only for FE
  New = 'New'
}

export enum MaterialType {
  Cement = 'Cement',
  Clinker = 'Clinker',
  IntermediateAndFinishedProducts = 'IntermediateAndFinishedProducts',
  RawMaterials = 'RawMaterials',
  Fuels = 'Fuels',
  EnhancersForCement = 'EnhancersForCement',
  AdditivesForClinker = 'AdditivesForClinker',
  NonReportedMaterials = 'NonReportedMaterials',
  OtherGroundProductsThanCement = 'OtherGroundProductsThanCement',
  OtherPyroProductsThanClinker = 'OtherPyroProductsThanClinker'
}

export enum IncomingMaterialStatus {
  Overdue = 'Overdue',
  Delivered = 'Delivered',
  Unknown = 'Unknown',
  Planned = 'Planned',
  Cancelled = 'Cancelled'
}
